export const AUTH_REFRESH_TOKEN = 'AUTH_REFRESH_TOKEN';
export const AUTH_REFRESH_TOKEN_RESULT = 'AUTH_REFRESH_TOKEN_RESULT';
export const AUTH_CHANGE_PASSWORD_OPEN_MODAL = 'AUTH_CHANGE_PASSWORD_OPEN_MODAL';
export const AUTH_CHANGE_PASSWORD_REQUEST = 'AUTH_CHANGE_PASSWORD_REQUEST';
export const AUTH_CHANGE_PASSWORD_RESULT = 'AUTH_CHANGE_PASSWORD_RESULT';
export const AUTH_GET_PREFERENCES_REQUEST = 'AUTH_GET_PREFERENCES_REQUEST';
export const AUTH_GET_PREFERENCES_RESULT = 'AUTH_GET_PREFERENCES_RESULT';
export const AUTH_GET_AUTHENTICATION_DETAILS_REQUEST = 'AUTH_GET_AUTHENTICATION_DETAILS_REQUEST';
export const AUTH_GET_AUTHENTICATION_DETAILS_RESULT = 'AUTH_GET_AUTHENTICATION_DETAILS_RESULT';